module.exports = __webpack_public_path__ + "img/1.b7cea9e7.jpg";